import { render, staticRenderFns } from "./setCommunalRateLimit.vue?vue&type=template&id=529b34de"
import script from "./setCommunalRateLimit.vue?vue&type=script&lang=js"
export * from "./setCommunalRateLimit.vue?vue&type=script&lang=js"
import style0 from "./setCommunalRateLimit.vue?vue&type=style&index=0&id=529b34de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports